import React from "react";
import { MultipleEntry } from "./components/multipleEntry/multipleEntry.index";

export const renderFilterTitle = (filter: string | string[], label: string): React.ReactNode => {
    if (typeof filter === "string") {
        return `${label}: ${filter}`;
    }
    if (filter.length === 1) {
        return `${label}: ${filter[0]}`;
    }
    return <MultipleEntry selectedItems={filter} title={label} />;
};
